import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { Layout, Text, useTheme } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import EmptyCartBrandedIcon from '../../Assets/EmptyCartIcon.branded.svg';
import EmptyCartIcon from '../../Assets/EmptyCartIcon.svg';
import EmptyFavorites from '../../Assets/EmptyFavorites.svg';
import Image from '../../Components/Image';
import Empty from '../../Components/SVG/Empty';
import externalLinks from '../../Config/externalLinks';
import { capitalize } from '../../Helper';
import { getEnvValue } from '../../Helper/env';
import { getCartTerm } from '../../Helper/RemoteConfig';
import ThemeStyles from '../../Theme/styles';

const RAZZLE_BUILD_MODE = getEnvValue('RAZZLE_BUILD_MODE');
const isBranded = RAZZLE_BUILD_MODE === 'branded';
const EmptyMessage = {
  cart: "But it doesn't have to be.",
  favorites: "Let's help you look for the perfect restaurant that you'll love.",
  filter: "We couldn't find what you're looking for",
};
const EmptyData = ({
  title = '',
  subtitle = '',
  type = '',
  fill = '',
  svgWidth = 180,
  svgHeight = 180,
}) => {
  const store_theme = useTheme();
  const EmptyTitle = {
    cart: `${capitalize(getCartTerm())} is empty.`,
    favorites: 'No Favorites to show.',
    filter: 'No results found.',
  };

  const _getStyleProps = useCallback(() => {
    if (isBranded) {
      const fillColor = store_theme?.icon_color || '#2fd1a2';
      const secondary = fillColor ? fillColor : '#00e8ab';
      const thirdColor = fillColor || '#075';
      return {
        style: {
          '--primary-color': fillColor,
          '--secondary-color': secondary,
          '--third-color': thirdColor,
        },
      };
    }
    return {};
  }, [store_theme?.icon_color]);

  const SVG = useCallback(() => {
    const fillColor = fill || store_theme?.icon_color;
    if (type === 'cart') {
      const EmptyComponent = isBranded ? EmptyCartBrandedIcon : EmptyCartIcon;
      return (
        <EmptyComponent
          width={svgWidth}
          height={svgHeight}
          {..._getStyleProps()}
        />
      );
    } else if (type === 'favorites') {
      return <EmptyFavorites width={svgWidth} height={svgHeight} />;
    } else if (type === 'filter') {
      return <Empty width={svgWidth} height={svgHeight} fill={fillColor} />;
    } else if (type === 'group') {
      return (
        <Image
          source={{ uri: externalLinks.WHOLE_CREW }}
          style={[{ width: svgWidth }, styles.group]}
          resizeMode="contain"
        />
      );
    }
    return null;
  }, [
    fill,
    store_theme?.icon_color,
    svgHeight,
    svgWidth,
    type,
    _getStyleProps,
  ]);

  return (
    <Layout
      style={[
        ThemeStyles.fitWidthContainer,
        ThemeStyles.alignItemsCenter,
        ThemeStyles.justifyContentCenter,
        ThemeStyles.alignSelfCenter,
        styles.wrapper,
      ]}
    >
      {SVG()}

      <View style={[ThemeStyles.spacingTop, ThemeStyles.alignItemsCenter]}>
        <Text category="s1">
          {lodashIsEmpty(title) ? EmptyTitle[type] : title}
        </Text>
        <Text category="p2" status="primary" style={ThemeStyles.textCenter}>
          {lodashIsEmpty(subtitle) ? EmptyMessage[type] : subtitle}
        </Text>
      </View>
    </Layout>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: 'transparent',
  },
  group: {
    aspectRatio: 2 / 1,
    maxWidth: '100%',
  },
});

export default EmptyData;
